import { ofetch as v } from "ofetch";
import { getSubgraphEndPoint as h } from "../store/subgraph.mjs";
import { EnumType as m } from "../types/EnumType.mjs";
import { VariableType as y } from "../types/VariableType.mjs";
function $(t) {
  const e = [];
  for (const i in t) {
    const r = t[i];
    e.push(`${i}: ${f(r)}`);
  }
  return e.join(", ");
}
function f(t) {
  return t instanceof m ? t.value : t instanceof y ? `$${t.value}` : typeof t != "object" || t === null ? JSON.stringify(t) : Array.isArray(t) ? `[${t.map((i) => f(i)).join(", ")}]` : `{${Object.keys(t).filter(
    (i) => (
      // @ts-expect-error, it is temporarily being ignored
      ![void 0, null].includes(t[i])
    )
  ).map((i) => `${i}: ${f(t[i])}`).join(", ")}}`;
}
const E = (t) => {
  const e = {
    first: 1e3
  };
  return t !== void 0 && (t.skip !== void 0 && t.skip > 0 && (e.skip = t.skip), t.first !== void 0 && t.first > 0 && (e.first = t.first)), e;
};
async function O(t, e) {
  const i = {};
  let r;
  return await new Promise((u, c) => {
    const o = (a, s) => {
      const l = $(s), g = a(l), p = h();
      v(p, {
        method: "POST",
        mode: "cors",
        body: { query: g }
      }).then((n) => {
        if (n.errors !== void 0) {
          c(n.errors[0].message);
          return;
        }
        if (n.data === void 0) {
          c(new Error("Subgraph is not available:" + p));
          return;
        }
        if (r = Object.keys(n.data)[0], i[r] = i[r] === void 0 ? n.data[r] : i[r].concat(n.data[r]), n.data[r]?.length === 1e3) {
          const d = {
            ...s,
            skip: s?.skip ?? 1e3
          };
          o(a, d);
        } else
          u(i);
      });
    };
    o(t, e);
  });
}
export {
  E as getCommonQuery,
  O as graphRequest,
  $ as jsonToQueryString
};
//# sourceMappingURL=graphql.mjs.map
